function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
/**
 * @description 按钮组件
 */


import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base';
import { uiSizeType } from '../base/types';
import { filterCopy } from '../utils';
import './index.less';

var Button = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(Button, _KZUIComponent);

  var _super = _createSuper(Button);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this, props);

    _this.autoBind('handleClick');

    return _this;
  }

  _createClass(Button, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled,
          loading = _this$props.loading;

      if (onClick && !disabled) {
        // 组件为加载类型
        if (loading) return;
        onClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var clsPrefix = 'kui-button';

      var _this$props2 = this.props,
          className = _this$props2.className,
          style = _this$props2.style,
          shadow = _this$props2.shadow,
          type = _this$props2.type,
          size = _this$props2.size,
          loading = _this$props2.loading,
          disabled = _this$props2.disabled,
          children = _this$props2.children,
          others = _objectWithoutProperties(_this$props2, ["className", "style", "shadow", "type", "size", "loading", "disabled", "children"]);

      var cls = classNames(clsPrefix, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "__").concat(type), !!type), _defineProperty(_classNames, "".concat(clsPrefix, "__").concat(size), !!size), _defineProperty(_classNames, "".concat(clsPrefix, "__loading"), loading), _defineProperty(_classNames, "".concat(clsPrefix, "__disabled"), disabled), _defineProperty(_classNames, "".concat(clsPrefix, "__shadow"), shadow), _classNames), className); // icon button

      var iconEl = null;

      if (loading) {
        iconEl = /*#__PURE__*/React.createElement("i", {
          className: "".concat(clsPrefix, "--load-icon kz-e-loading-button")
        });
      }

      var extraProps = filterCopy(others, 'last');
      return /*#__PURE__*/React.createElement("button", _extends({}, extraProps, {
        className: cls,
        onClick: this.handleClick,
        style: style
      }), iconEl, children);
    }
  }]);

  return Button;
}(KZUIComponent);

Button.defaultProps = {
  type: 'normal',
  size: '',
  shadow: false,
  disabled: false,
  loading: false,
  onClick: null
};
Button.propTypes = {
  type: PropTypes.oneOf(['normal', 'primary', 'danger', 'dashed', 'disabled', '']),
  loading: PropTypes.bool,
  size: uiSizeType,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  shadow: PropTypes.bool
};
export default Button;